export enum AlertLevel {
    Success,
    Warning,
    Error
}